import styled from 'styled-components';

const StyledContent = styled.div`
  .identity__field #password__message {
    display: none;
  }
  .identity__password-hint {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 16px;
    }
  }
  .identity__password-hints-wrapper {
    margin-top: 10px;
  }
`;

export default StyledContent;
